import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ZoneService} from '../../../zone/zone.service';
import {DienstService} from '../../../dienst/dienst.service';
import {Observable} from 'rxjs';
import {Zone} from '../../../zone/zone';
import {Thuisverzorger} from '../../../thuisverzorger/thuisverzorger';
import {ThuisverzorgerService} from '../../../thuisverzorger/thuisverzorger.service';
import {map, mergeMap} from 'rxjs/operators';
import {Diensten} from '../../../dienst/diensten';

@Component({
    templateUrl: './thuisverzorger.page.html',
    styleUrls: ['./thuisverzorger.page.scss'],
    standalone: false
})
export class ThuisverzorgerPage implements OnInit {
  private thuisverzorgerService = inject(ThuisverzorgerService);
  private zoneService = inject(ZoneService);
  private dienstService = inject(DienstService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  thuisverzorger$: Observable<Thuisverzorger>;
  zones$: Observable<Array<Zone>>;
  diensten$: Observable<Diensten>;

  ngOnInit(): void {
    this.thuisverzorger$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('id')),
        mergeMap(id => this.thuisverzorgerService.getThuisverzorgerById$(id)),
      );
    this.zones$ = this.zoneService.getZones$();
    this.diensten$ = this.dienstService.getDiensten$();
  }

  onCancelClicked(): void {
    this.navigateToThuisverzorgers();
  }

  onEditClicked(thuisverzorger: Thuisverzorger): void {
    this.thuisverzorgerService.updateThuisverzorger$(thuisverzorger)
      .subscribe(() => this.navigateToThuisverzorgers());
  }

  private navigateToThuisverzorgers(): void {
    this.router.navigateByUrl('/thuisverzorgers');
  }
}
